import React, { useCallback, useState } from 'react';

import TextArea from '../../../common2/TextArea';
import ItemPicturesUploader from '../common/ItemPicturesUploader';
import useStepValidation from '../common/useStepValidation';
import { wholeDamageInfoValidator } from '../claimValidators';
import SidePanelContentHeader from '../../../common2/side-panel/SidePanelContentHeader';
import CustomerCommentInput from '../common/CustomerCommentInput';
import Column from '../../../common/layout/Column';
import InputHelpLink from '../InputHelpLink';
import OptionalCarrierCaseIdInput from '../common/OptionalCarrierCaseIdInput';

function WholeDamageInfoStep(props) {
  const {
    as: Container,
    onChange,
    claim,
    claim: { wholeDamageInfo },
    onNext,
    carriers,
  } = props;

  const [errors, onClickNext] = useStepValidation(claim, onNext, wholeDamageInfoValidator);
  const [isDisabled, setIsDisabled] = useState(false);

  const onInputChange = useCallback((value, name) => onChange({ [name]: value }), [onChange]);

  const uploaderHelpLinkElement = (
    <InputHelpLink to="https://support.portal.sevensenders.com/support/solutions/articles/15000048062-submission-document-requirements#Damage-Photo-Requirements%C2%A0">
      Damage photo requirements
    </InputHelpLink>
  );

  return (
    <Container {...props} onNext={onClickNext} isDisabled={isDisabled}>
      <SidePanelContentHeader>Damage information</SidePanelContentHeader>
      <Column spacing="small">
        <TextArea
          label="WHOLE_DAMAGE_DESC"
          value={wholeDamageInfo}
          onChange={onInputChange}
          name="wholeDamageInfo"
          helpText="WHOLE_DAMAGE_TEXT_AREA_HELP"
          error={errors.wholeDamageInfo}
          isRequired
          noErrorTranslation
        />
        <CustomerCommentInput claim={claim} onChange={onInputChange} />
        <OptionalCarrierCaseIdInput
          claim={claim}
          carriers={carriers}
          value={claim.lmcCaseId}
          error={errors.lmcCaseId}
          onChange={onInputChange}
        />
        <ItemPicturesUploader
          name="picturesOfDamage"
          label="Pictures of damage"
          helpText="CLAIMS_DAMAGE_PICTURES_HELP_TEXT"
          claim={claim}
          errors={errors}
          onChange={onInputChange}
          onBusy={setIsDisabled}
          uploaderHelpLinkElement={uploaderHelpLinkElement}
        />
      </Column>
    </Container>
  );
}

export default React.memo(WholeDamageInfoStep);
